export const getAppointmentUrl = (selectedStoreGlobalId: string) => ({
    nl: `https://www.pearle.be/nl_BE/maak-afspraak/when?typeId=18459772&storeId=${selectedStoreGlobalId}`,
    fr: `https://www.pearle.be/fr_BE/prendre-rendez-vous/when?typeId=18459772&storeId=${selectedStoreGlobalId}`,
});
